// extracted by mini-css-extract-plugin
export var infoItem = "_rg-2";
export var title = "_rg-0";
export var value = "_rg-1";